<template>
  <v-dialog
    persistent
    :value="value"
    @input="$emit('input', $event)"
    max-width="450"
  >
    <v-card v-if="!backupCodes.length">
      <v-card-title> Generate New Backup Codes </v-card-title>
      <v-divider class="mb-2" />
      <v-card-text class="text-subtitle-1">
        Click the button below to generate new backup codes.
        <br />
        The old codes will be deleted and replaced with new ones. Please store
        the new codes securely.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          depressed
          class="text-capitalize"
          text
          @click="$emit('input', false)"
          >Cancel</v-btn
        >
        <v-btn
          depressed
          class="text-capitalize"
          color="primary"
          @click="generateCodes()"
          >Generate New Codes</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title> New Backup Codes </v-card-title>
      <v-divider class="mb-2" />
      <v-card-text class="text-subtitle-1">
        Please save the backup codes below in case you lose access to your
        authenticator app.

        <v-sheet rounded="lg" color="grey lighten-3" class="pa-4 mt-2">
          <v-row no-gutters v-for="(code, i) in backupCodes" :key="i">
            <v-col cols="12" class="text-body-2 font-weight-medium">{{
              code?.trim()
            }}</v-col>
          </v-row>
        </v-sheet>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          depressed
          class="text-capitalize"
          color="primary"
          @click="$emit('input', false)"
          >Got It <v-icon right>mdi-thumb-up</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import pageMixin from '@/mixins/page.mixin';
import { mapGetters } from 'vuex';
import { AppService } from '@/modules/shared/services/app.service';
export default {
  mixins: [pageMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      backupCodes: []
    };
  },
  watch: {
    value(v) {
      if (!v) this.backupCodes = [];
    }
  },
  computed: {
    ...mapGetters('authModule', ['user'])
  },
  methods: {
    async generateCodes() {
      try {
        const service = new AppService();
        const { data } = await service.generateBackupCodes();
        this.backupCodes = data.codes;

        this.showSnack({
          color: 'success',
          title: 'Backup codes generated',
          message: 'Please save these codes in a safe place.'
        });
      } catch (error) {
        this.showSnack({
          color: 'error',
          title: `Unable to generate backup codes`,
          message: error?.response?.data?.message || `Please try again later.`
        });
      }
    }
  }
};
</script>
